import update from 'immutability-helper'

export function updateObjectInList(list, searchBy, searchValue, newProps) {
  let objectIndex = list.findIndex(o => o[searchBy] === searchValue)
  let updatedObject = {
    ...list[objectIndex],
    ...newProps
  }
  return update(list, { $splice: [[objectIndex, 1, updatedObject]] })
}